var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ba-w-100"},[(_vm.pages.length > 0)?_c('div',{staticClass:"container-box"},_vm._l((_vm.pages),function(page,index){return _c('site-card-restore-page',{key:("page-" + index),attrs:{"page":page,"website":_vm.website},on:{"restored":_vm.redirect}})}),1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-142baef8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/pages/WebsiteRestorePages.vue
// module id = null
// module chunks = 